<template>
  <div class="yewu">
    <h1>{{$t('home.comBusiness')}}</h1>
    <div class="yewu_list">
      <div class="yewu_items" @click="go('MaiJiaAdvertising')">
        <img src="@/assets/images/maijia-logo.png" alt />
        <p>{{$t('home.maijia')}}</p>
        <p>为品牌提供品效合一服务</p>
        <img src="@/assets/images/right_arrow.png" alt />
      </div>
      <div class="yewu_items" @click="go('https://www.duomai.com')">
        <img src="@/assets/images/maimeng-logo.png" alt />
        <p>{{$t('home.maimeng')}}</p>
        <p>专注全球新零售效果营销服务</p>
        <img src="@/assets/images/right_arrow.png" alt />
      </div>
      <div class="yewu_items">
        <img src="@/assets/images/shaomai-logo.png" alt />
        <p>{{$t('home.shaomai')}}</p>
        <p>致力于成为内容第一的全平台MCN机构</p>
        <!-- <img src="@/assets/images/right_arrow.png" alt /> -->
      </div>
      <div class="yewu_items" @click="go('RuJiaCulture',true)">
        <img src="@/assets/images/mailang-logo.png" alt />
        <p>{{$t('home.mailang')}}</p>
        <p>LIVE × Video，一站式电商融媒体聚合服务专家</p>
        <!-- <img src="@/assets/images/right_arrow.png" alt /> -->
      </div>
      <div class="yewu_items">
        <img src="@/assets/images/youmai-logo.png" style="opacity: 0" alt />
        <!-- <p>{{$t('home.youmai')}}</p>
        <p>专注新媒体运营、社会化营销服务</p> -->
        <p>{{$t('home.xiaomai')}}</p>
        <p>为品牌提供全域电商代运营服务</p>
        <!-- <img src="@/assets/images/right_arrow.png" alt /> -->
      </div>
      <div class="yewu_items">
        <img src="@/assets/images/shaomai-logo.png" alt />
        <p>{{$t('home.maitian')}}</p>
        <p>致力于做最好的社会化营销工具</p>
        <!-- <img src="@/assets/images/right_arrow.png" alt /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    go(data) {
      const url = data.includes("MaiJiaAdvertising")
        ? `${window.location.href}${data}`
        : data;
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.yewu {
  padding: 36px 47.5px 47px;
  & > h1 {
    margin-bottom: 24px;
  }
  & .yewu_list {
    display: flex;
    flex-wrap: wrap;
    & .yewu_items:active {
      transition: all 500ms ease;
      transform: scale(0.9);
    }
    & .yewu_items {
      width: 130px;
      height: 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 25px 10px 0;
      position: relative;
      box-sizing: border-box;
      & > img:nth-child(1) {
        width: 70px;
        height: 30px;
      }
      & > p:nth-child(2) {
        font-size: 15px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 12px;
        padding: 10px 0 7px;
      }
      & > p:nth-child(3) {
        font-size: 10px;
        color: #cccccc;
        letter-spacing: 0;
        text-align: center;
        line-height: 14px;
      }
      & > img:nth-child(4) {
        position: absolute;
        bottom: 19px;
        width: 22px;
        height: 22px;
      }
    }
    & .yewu_items:nth-child(1) {
      margin-right: 20px;
      margin-bottom: 20px;
      background-image: url("../../assets/images/maijia-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    & .yewu_items:nth-child(2) {
      margin-bottom: 20px;
      background-image: url("../../assets/images/maimeng-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    & .yewu_items:nth-child(3) {
      margin-right: 20px;
      background-image: url("../../assets/images/shaomai-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 20px;
    }
    & .yewu_items:nth-child(4) {
      background-image: url("../../assets/images/mailang-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 0;
      margin-bottom: 20px;
    }
    & .yewu_items:nth-child(5) {
      margin-right: 20px;
      background-image: url("../../assets/images/youmai-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    & .yewu_items:nth-child(6) {
      background-image: url("../../assets/images/maitian-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 0;
    }
  }
}
</style>